import { useContext, useEffect, useState } from "react";
import { AuthContext, UserAuthStatus } from "../context/authContext";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export const withAuth = (WrappedComponent) => {
  function WithAuthComponent(props) {
    const { authStatus, attrInfo } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
      if (authStatus !== UserAuthStatus.SignedIn) return;
      if (!attrInfo?.length) return;

      const phoneVerified = attrInfo.find(
        (attr) => attr.Name === "phone_number_verified"
      )?.Value;

      const phoneNumber = attrInfo.find(
        (attr) => attr.Name === "phone_number"
      )?.Value;

      const email = attrInfo.find((attr) => attr.Name === "email")?.Value;
      const flowType = attrInfo.find(
        (attr) => attr.Name === "custom:registration_method"
      )?.Value;

      const domain = email?.split("@")[1];

      const mustChangeEmail =
        phoneVerified === "true" &&
        phoneNumber &&
        flowType === "store_flow" &&
        domain === "vestelkimlik.com";

      if (mustChangeEmail) {
        // Eğer kullanıcı /change-email'de değilse oraya yönlendir
        if (location.pathname !== "/change-email") {
          navigate("/change-email", { replace: true });
        }
      }

      // 1. Telefon numarası yoksa → verify/phone
      if (!phoneNumber || phoneNumber === "") {
        if (location.pathname !== "/verify/phone") {
          navigate("/verify/phone", { replace: true });
        }
      }
      // 2. Telefon numarası var ama doğrulanmamışsa → verify/code
      else if (phoneVerified !== "true") {
        if (!location.pathname.startsWith("/verify")) {
          navigate("/verify/code", { replace: true });
        }
      }
      // 3. Telefon doğrulandı ve verify altındaysa → home
      else if (
        phoneVerified === "true" &&
        location.pathname.startsWith("/verify")
      ) {
        navigate("/", { replace: true });
      }

      setChecked(true);
    }, [authStatus, attrInfo, location.pathname, navigate]);

    if (authStatus === UserAuthStatus.Loading || !checked) return null;

    if (authStatus !== UserAuthStatus.SignedIn) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <WrappedComponent {...props} />;
  }

  return WithAuthComponent;
};
